<app-boards-rail-controls #controls />

<div class="boards-shell">
  <!-- First paint: the loading skeleton (ported BoardsLoading, three panels: the Dynamic Panel loads on its own) until the boards have loaded; a failed load shows the list's own error. -->
  @if (!boards.boardsLoaded() && !boards.boardsLoadError()) {
    <app-boards-loading class="absolute inset-0 z-50" />
  }
  <app-collapsible-rail-shell
    class="boards-rail"
    [app]="app"
    [actionsTemplate]="controls.actionsTemplate()"
    [temporaryParked]="railFolded()"
    (temporaryUnparked)="fullWindow.reopenRail()"
  >
    <app-boards-sidebar (openFolder)="openFolder($event)" (selectFolderContents)="openFolder($event, true)" />
  </app-collapsible-rail-shell>

  <div class="boards-rest">
    @if (editorStore.editorBoardId()) {
      <!-- The list folds to its edge tab beside the editor and opens beside it on a click. Only widths change, so the
           editor is never rebuilt by a pane change. -->
      <app-split-view
        side="left"
        key="boardsEditorList"
        [collapsedSize]="25"
        [shadow]="true"
        [magneticSize]="300"
        [withIcon]="true"
        [iconTop]="38"
        [temporaryCollapsed]="!editorListOpen()"
        (temporaryOpened)="editorListOpen.set(true)"
      >
        <app-boards-list
          split-left-pane
          class="list shadow-lg"
          [selectedBoardId]="boards.selectedBoardId()"
          [minimized]="editorListMinimized()"
          [besideEditor]="true"
          (previewBoard)="switchTo($event.id)"
          (openBoard)="switchTo($event.id)"
          (doubleClickBoard)="editBoard($event.id)"
          (openFolder)="openFolder($event.id, $event.selectAll, true)"
          (folderBoardCreated)="openCreatedFolderBoard($event.folderId, $event.boardId)"
        />
        <app-boards-editor split-right-pane class="block h-full shadow-lg" [fourthPanelOpen]="dpOpen()" />
      </app-split-view>
    } @else {
      <app-split-view
        side="left"
        key="boardsList"
        [collapsedSize]="25"
        [shadow]="true"
        [magneticSize]="300"
        [withIcon]="true"
        [iconTop]="38"
      >
        <app-boards-list
          split-left-pane
          class="list shadow-lg"
          [selectedBoardId]="boards.selectedBoardId()"
          [minimized]="listMinimized()"
          (previewBoard)="boards.selectBoard($event.id)"
          (openBoard)="boards.selectBoard($event.id)"
          (doubleClickBoard)="editBoard($event.id)"
          (openFolder)="openFolder($event.id, $event.selectAll, true)"
          (folderBoardCreated)="openCreatedFolderBoard($event.folderId, $event.boardId)"
        />
        <div class="full-form shadow-lg" split-right-pane>
          @for (folder of previewFolders(); track folder.id) {
            <app-boards-folder-preview [folder]="folder" [selectAllRequest]="folderSelectAllRequest()" (contentsSelected)="folderSelectAllRequest.set(0)" (closed)="folderId.set(null)" />
          } @empty {
            <app-boards-preview [boardId]="boards.selectedBoardId()" />
          }
        </div>
      </app-split-view>
    }
  </div>
</div>
